import { ChangeEvent, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { validateDateRange } from '../../utils/dateTimeUtils';
import { addToast } from '../../utils/toastNotifications';
const FilterModal = ({
  close,
  show,
  callback,
}: {
  show: boolean;
  close: Function;
  callback?: Function;
}) => {
  const [filterParams, setFilterParams] = useState({
    fulfilmentStatus: '',
    statusText: '',
    startDate: '',
    endDate: '',
  });

  const handleChange =
    (input: string) => (event: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>) => {
      let statusText = '';
      if (input === 'fulfilmentStatus') {
        let selectEvent = event as ChangeEvent<HTMLSelectElement>;

        statusText = selectEvent.target.selectedOptions[0].text;

        setFilterParams({
          ...filterParams,
          fulfilmentStatus: event.target.value,
          statusText: statusText,
        });

        return;
      }

      setFilterParams({
        ...filterParams,
        [input]: event.target.value,
      });
    };

  const filter = (event: any) => {
    event.preventDefault();

    //validate input and use callback if available
    if (filterParams.startDate || filterParams.endDate) {
      const validationResult = validateDateRange(filterParams.startDate, filterParams.endDate);

      if (!validationResult.isValid) {
        addToast(validationResult.msg, 'error');
        return;
      }
    }

    if (callback) {
      callback(
        filterParams.fulfilmentStatus,
        filterParams.statusText,
        filterParams.startDate,
        filterParams.endDate
      );
    }

    close();
  };

  return (
    <Modal show={show} onHide={() => close()} centered>
      <Modal.Header className='bg-green' closeButton>
        <Modal.Title style={{ color: '#fff' }}>Filter Fulfilments</Modal.Title>
      </Modal.Header>
      <form id='filter-form' className='bg-green-light'>
        <Modal.Body>
          <div className='form-group'>
            <label>Start Date</label>
            <input
              type='date'
              className='form-control'
              value={filterParams.startDate}
              onChange={handleChange('startDate')}
            />
          </div>
          <div className='form-group'>
            <label>End Date</label>
            <input
              type='date'
              value={filterParams.endDate}
              className='form-control'
              onChange={handleChange('endDate')}
            />
          </div>
          <div className='form-group'>
            <label>Status</label>
            <select
              className='custom-select'
              value={filterParams.fulfilmentStatus}
              onChange={handleChange('fulfilmentStatus')}
            >
              <option value=''>All</option>
              <option value='Pending'>Pending</option>
              <option value='Processing,Dispensed,InReview'>Processing</option>
              <option value='Approved'>Ready</option>
              <option value='Completed'>Completed</option>
              <option value='Cancelled'>Cancelled</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button className='btn btn-warning'>Clear</button>
          <button
            className='btn btn-primary bg-green'
            type='submit'
            onClick={filter}
            // style={{ backgroundColor: '#1489C8' }}
          >
            Filter
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default FilterModal;
